import { ArrowLeftTopIcon } from './ArrowLeftTopIcon';

/**
 * author: Colton Wiscombe
 * id 4FB19260-E56B-411D-B0A6-22D15C3299A3
 * name arrow-left-top
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-top.svg
 * tags
 */
export const TurnLeftIcon = ArrowLeftTopIcon;
export default TurnLeftIcon